<template>
  <div
      :style="{
      'font-size': fontSize ? `${fontSize}rem` : '',
      'min-height': size ? `${size}rem` : ''
    }"
      class="thumb"
  >
    <div
        :style="
        item && ((item as any)?.rarity_color)
          ? `
          color: ${(item as any)?.rarity_color};`
          : null
      "
        class="thumb_bg"
    />
    <!--        class="thumb_bg"-->
    <img
        :alt="props.alt || (item as any)?.market_hash_name || (item as any)?.full_name ||  'item image'"
        :fetchpriority="fetchpriority || 'auto'"
        :height="imageHeight || 150"
        :loading="loading || 'lazy'"
        :src="getImage(item)"
        :style="{ height: height ? `${height}rem` : 'unset' }"
        :width="imageWidth || 230"
        decoding="async"
    />
  </div>
</template>

<script lang="ts" setup>
import {useResize} from '~/composables/resize'
import type {
  AdvancedSearchBody,
  FamilySimilarSkins,
  Item,
  ItemPageInfo,
  ItemsByField
} from "~/graphql/generated/schema-types";
import {getImageFromProxy, getImageFromWaxpeer} from "~/utils/get-image-url";

const currW = useResize()

const props = defineProps<{
  item: ItemsByField | Item | ItemPageInfo | FamilySimilarSkins | AdvancedSearchBody
  src?: string
  fontSize?: number
  size?: number
  height?: number
  imageSizes?: string
  imageWidth?: number
  imageHeight?: number
  loading?: 'eager' | 'lazy',
  useProxy?: boolean | undefined
  alt?: string,
  fetchpriority?: 'high' | 'low' | 'auto'
}>()

// const isMounted = ref(false)

const getImage = (item: any) => {
  if (props.src) {
    return (props.src.includes('imageproxy') || !props.useProxy) ?
        props.src :
        getImageFromProxy(props.src, props.imageSizes)
  }

  return getImageFromWaxpeer(item.market_hash_name || item.market_hash_name, props.imageSizes)
}

// onMounted(() => {
//   isMounted.value = true
// })
</script>

<style lang="scss" scoped>

@use 'sass:color';

.thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  width: 100%;
  position: relative;
  margin: auto;

  &_bg {
    display: block;
    font-size: inherit;
    transition: 0.3s;
    position: absolute;

    &:before,
    &:after {
      content: '\e81f';
      font-family: 'fontello';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &:before {
      filter: blur(0.1em);
      color: inherit;
      // opacity: 0.3;
      opacity: 0.2;
    }

    &:after {
      color: rgba(255, 255, 255, 0.025);
    }
  }

  img {
    width: 100%;
    height: 100%;
    position: relative;
    max-height: 38rem;
    font-size: 0;

    &[lazy='error'],
    &[lazy='loading'] {
      width: 75%;
    }
  }
}
</style>
